// extracted by mini-css-extract-plugin
export var dropdownIcon = "_sn-6";
export var imgContainer = "_sn-3";
export var menuIcon = "_sn-5";
export var pillWrapper = "_sn-2";
export var pillsContainer = "_sn-1";
export var subscriptionCard = "_sn-0";
export var subscriptionLogo = "_sn-4";